<template>
    <div class="page-wrap">
        <div class="session-form-hold">
            <base-card>
                <v-card-text class="text-center">
                    <!-- <v-avatar size="60" class="mb-4">
                        <img src="@/assets/images/logo.svg" alt="" />
                    </v-avatar>                                         -->
                    <img src="@/assets/images/adpoints-logo-w.png" alt="" />
                    <v-form  v-if="!submitted" v-model="formValid">
                        <h5>Lets get started</h5>
                        <h6 class="text--disabled font-weight-medium mb-10">
                        Sign up to use the platform
                        </h6>
                        <v-text-field 
                            label="Email" 
                            v-model="email"
                            :rules="emailRules"      
                            :validate-on-blur="true"
                        />
                        <v-text-field
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            name="input-10-2"
                            label="Password" 
                            :rules="passwordRules"
                            ref="pwdField"
                            v-model="password"
                            @click:append="show = !show"        
                            :validate-on-blur="true"                    
                        ></v-text-field>
                        <v-text-field
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            name="input-10-2"
                            v-model="retypePassword"
                            label="Confirm Password"
                            :rules="retypePasswordRules"                            
                            @click:append="show = !show"   
                            :validate-on-blur="true"                         
                        ></v-text-field>    
                        <v-row>
                            <v-text-field 
                                label="Firstname" 
                                v-model="firstName"    
                                :rules="firstNameRules"
                                :validate-on-blur="true"
                                class="col-6"
                            />
                            <v-text-field 
                                label="Lastname" 
                                v-model="lastName"  
                                :rules="lastNameRules"  
                                :validate-on-blur="true"                          
                                class="col-6"
                            />                             
                        </v-row>                                       
                        <v-text-field 
                            label="Invitation Code" 
                            v-model="invitationCode"   
                            :rules="invitationCodeRules"  
                            :validate-on-blur="true"                          
                            
                        /> 
                        <v-alert dense outlined type="error" v-if="error">
                            {{ error }}
                        </v-alert>
                        <v-btn class="mb-4" 
                            block 
                            color="primary" 
                            @click="signUp" 
                            dark
                            :loading="loading"
                            
                        >Sign Up</v-btn>
                        <div class="d-flex justify-around flex-wrap">
                            <v-btn text small color="primary" to="/auth/login"
                                >Sign in to existing account</v-btn
                            >
                        </div>
                    </v-form>
                    <div v-else>
                        <h5>Activation Email Sent</h5>
                        <h6 class="text--disabled font-weight-medium mb-10">
                            You will receive an activation e-mail shortly, <br/>
                            so check your inbox to complete the signup process and create your account before logging in.
                        </h6>
                        <v-btn
                                text
                                small
                                color="primary"
                                to="/auth/login"
                                >Go to Login Screen</v-btn
                            >
                        <!-- <v-btn class="mb-4" block color="primary" to="/auth/signup" dark
                            >Go to Sign-In</v-btn> -->
                    </div>                    

                </v-card-text>
            </base-card>
        </div>
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            top
            tile
            color="red accent-2"
            >
            {{ snackbarMessage }}
    </v-snackbar>
    </div>
    
</template>
<script>
import {api} from "src/api/index";
import { fieldNotEmpty, fieldMinLength } from "src/core/vuetify-validators.js"

export default {
    name: 'SignUp',
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Sign Up'
    },
    data() {
        return {
            submitted: false,

            show: false,
            email: '',
            firstName: '',
            lastName: '',
            email: '',
            password: '',                        
            retypePassword: '',
            invitationCode: '',

            formValid: true,
            loading: false,
            snackbar: false,
            snackbarMessage: '',
            error: '',

            emailRules: [
                fieldNotEmpty,
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                (v) => fieldMinLength(v, 5)
            ],
            passwordRules: [
                fieldNotEmpty,             
                (v) => fieldMinLength(v, 8)                
            ],
            retypePasswordRules: [
                this.matchingPasswords
            ],
            firstNameRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)   
            ],
            lastNameRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)   
            ],
            invitationCodeRules: [
                fieldNotEmpty,            
            ]
        }
    },
    methods: {
        signUp(event) {      
            this.error = '';
            if(!this.formValid) {
                this.snackbarMessage = "There are invalid fields";
                this.snackbar = true;
                return;
            }                                
            this.loading = true;          
            api.auth.signUp({
                username: this.email,
                email: this.email,
                password: this.password,
                retypedPassword: this.retypePassword,
                firstName: this.firstName,
                lastName: this.lastName,
                invitationCode: this.invitationCode
            })
            .then((rsp)=>{                
                this.submitted = true;
            })
            .catch((error)=>{
                this.error = error.response.data.message;
                // this.snackbarMessage = 
                // this.snackbar = true;
            })
            .finally(()=>{
                this.loading = false;
            })            
        },
        matchingPasswords: function() {            
            if (this.password === this.retypePassword) {
                return true;
            } else {
                return 'Passwords do not match.';
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.page-wrap {
    background-color: #f2f4f4 !important;
    display: flex;
    align-items: center;
    padding: 40px 1rem;
    height: 100%;
    min-height: 100vh;
}
.session-form-hold {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}
</style>
